module.exports = __webpack_public_path__ + "img/avatars5.5e773260.png";